export default {
  // General
  app_name: 'mvplan',
  calculate: 'Calculate Decompression',
  save: 'Save',
  cancel: 'Cancel',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  reset: 'Reset to Defaults',
  confirm_reset: 'Reset all settings to defaults?',
  confirm_delete: 'Delete this item?',

  // Navigation
  nav_plan: 'Plan',
  nav_gases: 'Gases',
  nav_profile: 'Profile',
  nav_settings: 'Settings',
  nav_day: 'Day',

  // Day of diving
  day_title: 'Day of diving',
  day_empty: 'No dive in this day yet.',
  day_empty_hint: 'Add the dive of the plan screen to start a series.',
  day_add_current: 'Add the current dive',
  day_add_needs_segments: 'The plan screen holds no dive segment: nothing to add.',
  day_ask_surface_interval: 'Surface interval before this dive, in minutes:',
  day_invalid_surface_interval: 'Enter a surface interval of 0 min or more.',
  day_surface_interval: 'Surface interval',
  day_dive_label_placeholder: 'Dive name (optional)',
  day_calculate: 'Calculate the day',
  day_clear: 'Empty the day',
  day_confirm_clear: 'Remove every dive of this day?',
  day_remove_dive: 'Remove this dive',
  day_confirm_remove: 'The dives after it are chained to this one and will have to be calculated again.',
  day_dive_not_computed: 'Not calculated yet',
  day_dive_stale: 'Calculated before an edit: this plan no longer describes the series.',
  day_dive_refused: 'This dive was refused, see the previous dives of the series.',
  day_dives_refused: '{count} dive(s) could not be planned. The dives after them are chained to a dive that does not exist.',
  day_summary: 'Day total',
  day_dives_count: 'Dives',
  day_summary_partial: 'Totals cover the {computed} calculated dive(s) out of {total}.',
  day_editing_dive: 'You are editing dive {number} of the day.',
  day_save_into_day: 'Save into the day',
  day_detach: 'Detach',
  day_dive_number: 'Dive {number} of {total}',
  day_first_dive: 'First dive of the day',
  day_nothing_to_export: 'No dive of this day has been calculated yet: nothing to export.',
  day_export_failed: 'The document could not be produced. Try again, and check the browser console for the reason.',

  // Saved days
  saved_days_title: 'Saved days',
  saved_days_save: 'Save the day',
  saved_days_saved: 'Day saved',
  saved_days_save_failed: 'This day could not be saved: it holds no dive, or the storage is full.',
  saved_days_name_placeholder: 'e.g. Port-Cros, Saturday',
  saved_days_empty: 'No day saved yet.',
  saved_days_empty_hint: 'Build a day of diving, then save it to find it here.',
  saved_days_confirm_delete: 'Delete this day?',
  saved_days_import_error: 'This file is not a day of diving exported by mvplan.',

  // Settings
  settings_algorithm: 'Algorithm',
  settings_gf: 'Gradient Factors',
  settings_gf_low: 'GF Low',
  settings_gf_high: 'GF High',
  settings_rates: 'Rates & Stops',
  settings_descent: 'Descent',
  settings_ascent: 'Ascent',
  settings_deco_ascent: 'Between stops',
  settings_last_stop_ascent: 'Last stop ascent',
  settings_last_stop: 'Last stop',
  settings_safety_stop: 'Safety stop when no deco is owed (min, 0 = none)',
  settings_rmv: 'RMV',
  settings_rmv_bottom: 'Bottom',
  settings_rmv_deco: 'Deco / Bailout',
  settings_ccr: 'CCR Mode',
  settings_setpoint_mode: 'Setpoint Mode',
  settings_setpoint_fixed: 'Fixed',
  settings_setpoint_dynamic: 'Dynamic',
  settings_ppo2: 'ppO2 Limits',
  settings_ppo2_working: 'Working',
  settings_ppo2_deco: 'Deco',
  settings_display: 'Display',
  settings_units: 'Units',
  settings_units_metric: 'Metric (m, bar)',
  settings_units_imperial: 'Imperial (ft, psi)',
  settings_theme: 'Theme',
  settings_theme_dark: 'Dark',
  settings_theme_light: 'Light',
  settings_language: 'Language',
  settings_divers: 'Divers',
  settings_divers_hint: 'Names printed on PDF (comma-separated)',
  settings_dive_site: 'Dive Site',
  settings_dive_site_placeholder: 'e.g. Blue Hole, Dahab',
  settings_bailout: 'Bailout',
  settings_bail_delay: 'Bail delay (min)',
  settings_bail_delay_hint: 'Time at depth before ascending on bailout',
  settings_rmv_stress: 'Stress RMV',
  settings_stress_until: 'Stress until',
  settings_stress_first_stop: 'First stop',
  settings_stress_gas_switch: 'Gas switch',
  settings_stress_surface: 'Surface',
  settings_time_and_gas: 'Time and gas switches',
  settings_descent_included: 'Descent time included',
  settings_descent_included_hint: 'Descent time is included in segment duration',
  settings_gas_switch_duration: 'Gas switch duration',
  settings_gas_switch_at_stop: 'Switch gas at deco stop only',
  settings_gas_switch_at_stop_hint: 'If disabled, gas switch happens as soon as MOD allows (more optimal)',
  settings_gf_presets: 'GF Presets',
  settings_gf_presets_hint: 'Quick access in Plan view',
  settings_gf_add_preset: 'Add preset',
  settings_gf_preset_name: 'Name',
  settings_gf_custom: 'Custom',
  settings_environment: 'Environment',
  settings_gas_temp: 'Gas temp.',
  settings_water_type: 'Water type',
  settings_water_salt: 'Salt water',
  settings_water_fresh: 'Fresh water',
  settings_water_brackish: 'Brackish water',
  settings_water_red_sea: 'Red Sea',
  settings_water_custom: 'Custom density',
  settings_water_density: 'Water density',
  settings_water_density_hint: 'Water density changes the pressure actually felt at a given depth, and therefore the length of the stops. Reference values: 10000 in fresh water, 10150 in brackish water, 10300 at sea, 10400 in the Red Sea (10300 stands for 1.03 kg/l). Accepted values: {min} to {max}.',
  settings_altitude: 'Altitude',
  settings_environment_hint: 'Gas temp. = lung temperature for density calculation (~35°C). Altitude and water type also change the decompression calculation.',
  settings_alerts: 'Safety alerts',
  settings_alerts_hint: 'Disable certain alerts for experienced divers',
  settings_alerts_narcosis: 'Narcosis alerts (END)',
  settings_alerts_density: 'Density alerts (CO2)',
  settings_alerts_show_density: 'Always show gas density',
  settings_ccr_flush: 'Loop flushes (CCR)',
  settings_ccr_flush_hint: 'Adds a flush editor to the plan screen for rebreather dives.',
  settings_ccr_flush_duration: 'Default flush duration (min)',
  settings_ccr_o2_flush: 'Finish the dive on 100% oxygen',
  settings_ccr_o2_flush_hint: 'At the depth you set, the loop goes to pure oxygen and stays on it to the surface.',
  settings_ccr_o2_flush_depth: 'Depth (m)',
  settings_ccr_o2_flush_time: 'Flush duration (min)',
  settings_ccr_o2_flush_invalid: 'Unusable depth or duration.',
  settings_alerts_icd: 'ICD alerts (inner ear)',
  settings_pdf: 'PDF export',
  settings_pdf_include_profile: 'Include dive profile',
  settings_pdf_include_profile_hint: 'Disable to fit on a single A4 page',
  settings_school_mode: 'School mode',
  settings_school_mode_hint: 'Compare GF presets on the profile chart',
  settings_chart_scale: 'Chart scale',
  settings_school_presets: 'Presets to compare',
  profile_school_compare: 'GF Comparison',
  profile_school_tts: 'TTS',
  profile_school_stops: 'Stops',

  // Gases
  gases_title: 'Gas Mixes',
  gases_bailout: 'Bailout Gases',
  gases_diluents: 'Diluents',
  gases_name: 'Name',
  gases_mod: 'MOD',
  gases_end: 'END',
  gases_ppo2_max: 'ppO2 max',
  gases_use_bailout: 'Use as bailout gas',
  gases_tank_config: 'Tank Configuration',
  gases_volume: 'Volume (L)',
  gases_pressure: 'Pressure (bar)',
  gases_capacity: 'Capacity',

  // Plan
  plan_segments: 'Dive Segments',
  plan_depth: 'Depth',
  plan_time: 'Time',
  plan_runtime: 'Runtime',
  plan_gas: 'Gas',
  plan_setpoint: 'SP',
  plan_no_segments: 'No segments. Add one to start planning.',
  plan_config: 'Configuration',
  plan_ccr: 'CCR Plan',
  plan_bailout: 'Bailout (Worst Case)',
  plan_deco: 'Decompression Schedule',
  plan_no_deco: 'No decompression required',
  plan_stops_summary: 'Deco Stops Summary',
  duration_hours_minutes: '{h}h{m}',
  duration_hours: '{h}h',
  duration_minutes: '{m} min',
  plan_desat_sea_level: 'Staying at sea level, you will be fully desaturated {time} after leaving the water.',
  plan_desat_altitude: 'Staying at {altitude} m of altitude, you will be fully desaturated {time} after leaving the water.',
  plan_desat_over: 'Full desaturation takes more than {time} after leaving the water.',
  plan_no_fly: 'No-fly (DAN)',
  plan_no_fly_minimum: '> {time}',
  plan_no_fly_dan_rule: 'Delay before flying, DAN consensus recommendations: a minimum of {noStop} surface interval for the single no-decompression dive; a minimum of {multiDay} surface interval for multi-day repetitive diving; substantially longer than {longer} after diving involving compulsory decompression, or using heliox and trimix. This is not a desaturation computation.',
  plan_no_fly_dan_case_no_stop: 'This dive falls under the first case: a single dive with no decompression stop.',
  plan_no_fly_dan_case_repetitive: 'This dive falls under the second case: repetitive diving.',
  plan_no_fly_dan_case_deco: 'This dive falls under the third case: compulsory decompression. The delay shown is a floor to be exceeded, not a recommended value.',
  plan_no_fly_dan_case_helium: 'This dive falls under the third case: a helium mix. The delay shown is a floor to be exceeded, not a recommended value.',
  plan_no_fly_dan_source: 'Source: DAN, Guidelines for Flying After Diving, consensus of the Flying After Recreational Diving Workshop (2002). Those trials were run in a dry chamber with resting volunteers: longer delays may be needed for divers who are immersed and exercising.',
  plan_tts: 'TTS',
  plan_cns: 'CNS',
  plan_otu: 'OTU',
  plan_cns_series: 'CNS (day)',
  plan_otu_series: 'OTU (day)',
  plan_gas_requirements: 'Bailout Gas Requirements',
  plan_gas_consumption: 'Gas Consumption',
  plan_liters: 'Liters',
  plan_type: 'Type',
  plan_ppo2: 'ppO2',
  plan_density: 'Density',
  plan_tissue: 'Tissue',
  plan_flush: 'Loop flushes',
  plan_flush_hint: 'Deliberate flushes of the loop during the ascent, deepest first. During a flush the loop breathes the chosen mix at ambient pressure, not the setpoint.',
  plan_flush_add: 'Add a flush',
  plan_flush_none: 'No flush planned',
  plan_flush_depth: 'Depth',
  plan_flush_gas: 'Flush with',
  plan_flush_time: 'Duration',
  plan_flush_keep: 'Keep this mix',
  plan_flush_keep_hint: 'The loop stays on the flushed mix until the surface, which is the deliberate helium purge before the decompression. Unticked, it goes back to the diluent in use: a flush is a gesture, not a gas change.',
  plan_flush_remove: 'Remove',
  plan_flush_figures: '{gas} at {depth} m: ppO2 {ppO2} bar, END {end} m, density {density} g/L',
  plan_o2_flush_row: 'Finish on oxygen: {time} min of flush at {depth} m, loop kept on oxygen to the surface.',
  plan_o2_flush_source: 'Set in the CCR settings, not editable here.',
  plan_o2_flush_skipped_setting: 'The oxygen finish of the settings has an unusable depth or duration and is not applied.',
  plan_o2_flush_skipped_clash: 'The oxygen finish of the settings steps aside at {depth} m: a flush of your own is already planned there.',
  plan_o2_flush_skipped_too_deep: 'The oxygen finish planned at {depth} m is not applied: this dive never goes below {maxDepth} m.',
  plan_flush_helper: 'Compute',
  plan_flush_helper_title: 'Flush depth',
  plan_flush_helper_hint: 'Say what you are aiming for and the depth that gives it is computed, for the mix of this flush and for the water and altitude of the site.',
  plan_flush_helper_mix: 'Flush mix',
  plan_flush_helper_target: 'Aim for',
  plan_flush_target_ppo2: 'ppO2 (bar)',
  plan_flush_target_end: 'END (m)',
  plan_flush_helper_result: '{depth} m ({exact} m exactly)',
  plan_flush_helper_rounding: 'Rounded to the shallower metre, so the figures below are the ones the plan will hold.',
  plan_flush_helper_apply: 'Use this depth',
  plan_flush_helper_unreachable: 'No depth gives that with this mix.',
  plan_flush_helper_deeper: 'Deeper than the {maxDepth} m bottom: a flush happens on the way up.',
  plan_flush_helper_no_nitrogen: 'This mix carries no nitrogen: its END is zero at every depth.',
  plan_flush_helper_band: 'Outside your {min} - {max} bar working band.',
  plan_descent: 'Descent',
  plan_ascent: 'Ascent',
  plan_bottom: 'Bottom',
  plan_stop: 'Stop',
  plan_total_runtime: 'Total Runtime',
  plan_deco_time: 'Deco Time',
  plan_max_depth: 'Max Depth',
  plan_bottom_time: 'Bottom Time',
  plan_based_on_rmv: 'Based on RMV',
  plan_insufficient_gas: 'One or more tanks have insufficient capacity for this bailout!',
  plan_bars_needed: 'bars needed',

  // Profile
  profile_title: 'Dive Profile',
  profile_saturation: 'Tissue Saturation',
  profile_tap_details: 'Tap for details',
  profile_ceiling: 'Ceiling',
  profile_surface: 'Surface',
  profile_residual: 'Residual N2',
  profile_calculate_hint: 'Calculate a dive plan to see profile',
  profile_fullscreen: 'Fullscreen',


  // Units
  unit_meters: 'm',
  unit_feet: 'ft',
  unit_minutes: 'min',
  unit_bar: 'bar',
  unit_psi: 'psi',
  unit_lpm: 'L/min',

  // Additional Plan
  plan_add_segment: 'Add Segment',
  plan_edit_segment: 'Edit Segment',
  plan_diluent: 'Diluent',
  plan_dynamic_setpoint_info: 'Dynamic mode active',
  plan_override_setpoint: 'Override with fixed setpoint (optional)',
  plan_setpoint_auto: 'Auto',
  plan_mode: 'Mode',
  plan_algorithm: 'Algorithm',
  plan_export_pdf: 'Export PDF',
  plan_save_html: 'Save HTML',
  plan_calculate_first: 'Calculate a dive plan first',
  plan_segment_for: '{depth}m for {time} min',
  plan_gas_at_sp: '{gas} @ SP{sp}',
  plan_tank: 'Tank',
  plan_needed: 'Needed',
  plan_status: 'Status',
  plan_insufficient: 'INSUFFICIENT',
  plan_gas_tight: 'TIGHT',
  plan_ok: 'OK',
  plan_need_more: 'Need {liters}L ({bars} bar)',
  plan_left: '{liters}L left ({bars} bar)',
  plan_need_more_liters: 'Need {liters}L',
  plan_left_liters: '{liters}L left',
  plan_gas_unused: 'NOT BREATHED',
  plan_gas_unused_detail: '{liters}L carried, untouched by this plan',
  plan_gas_backup: 'Backup: {names}',

  // Gases additional
  gases_name_auto: 'Name (auto-generated if empty)',
  gases_auto_label: 'Auto label',
  gases_n2_calc: 'N2 % (calculated)',
  gases_end_at_mod: 'END @ MOD',
  gases_confirm_delete: 'Delete this gas?',
  gases_confirm_delete_diluent: 'Delete this diluent?',
  gases_only_diluent: 'Cannot delete the only diluent',
  gases_form_invalid: 'Unusable values: O2 above 0 % and at most 100 %, He from 0 % to below 100 %, their sum at most 100 %; ppO2 limit, cylinder volume and pressure above 0.',
  plan_segment_invalid: 'Enter a depth from 1 to 200 m, a time from 1 to 999 min, and a setpoint from 0.7 to 1.6 bar.',

  // Segment types
  segment_bail: 'BAIL',
  segment_desc: 'Desc',
  segment_asc: 'Asc',
  segment_bottom: 'Bottom',
  segment_stop: 'Stop',
  segment_gas_change: 'Gas sw.',
  segment_diluent_change: 'Dil. sw.',
  segment_flush: 'Flush',
  segment_safety_stop: 'Safety',

  // Saved Plans
  nav_saved: 'Saved',
  saved_plans_title: 'Saved Plans',
  saved_plans_save: 'Save Plan',
  saved_plans_saved: 'Plan saved!',
  saved_plans_empty: 'No saved plans yet',
  saved_plans_empty_hint: 'Calculate a dive plan and save it for later',
  saved_plans_load: 'Load',
  saved_plans_rename: 'Rename',
  saved_plans_duplicate: 'Duplicate',
  saved_plans_export: 'Export',
  saved_plans_confirm_delete: 'Delete this plan?',
  saved_plans_import: 'Import',
  saved_plans_import_error: 'Failed to import plan',
  saved_plans_name_label: 'Plan name',
  saved_plans_name_placeholder: 'Enter plan name',
  plan_share: 'Share',
  feature_next_version: 'Available in next version',

  // Dive environment carried by a plan: named in the exports and in the saved
  // plan list, and flagged when the plan on screen was computed for another one
  plan_environment_changed: 'This plan was calculated for another water type or another altitude. Calculate it again before diving it.',
  // Any other input the calculation reads (gradient factors, rates, ppO2
  // limits, gases, rebreather...) changed after the plan was computed
  plan_inputs_changed: 'This plan was calculated with other dive parameters. Calculate it again before diving it.',
  export_environment: 'Environment',
  saved_plan_environment: 'Environment',

  // PDF Export
  pdf_title: 'Dive Plan - mvplan',
  pdf_exporting: 'Generating PDF...',
  pdf_generated: 'Generated',
  pdf_mode_oc: 'Open Circuit',
  pdf_footer_generated: 'Generated by mvplan - Technical Dive Planner',
  pdf_footer_verify: 'Always verify your dive plan and carry backup tables',

  // PDF format choice
  pdf_choose_format: 'PDF format',
  pdf_choose_format_hint: 'Choose which document to export',
  pdf_format_complete: 'Full',
  pdf_format_complete_hint: 'Detailed multi-page report (tables, profile, gas)',
  pdf_format_condensed: 'Condensed (1 page)',
  pdf_format_condensed_hint: 'Single-page printable planning sheet',

  // PDF condensed form
  pdf_form_title: 'Dive planning',
  pdf_form_date: 'Date',
  pdf_form_team: 'Team no.',
  pdf_form_diver: 'Diver',
  pdf_form_lastname: 'First/Last name',
  pdf_form_machine: 'Machine',
  pdf_form_gf: 'Grad. Fac.',
  pdf_form_runtime_title: 'Run Time',
  pdf_form_planned_depth: 'Planned depth',
  pdf_form_planned_bottom: 'Planned bottom time',
  pdf_form_palier: 'Stop depth',
  pdf_form_descent: 'Descent',
  pdf_form_bottom: 'Bottom',
  pdf_form_duration: 'Duration',
  pdf_form_cumul: 'Cumul',
  pdf_form_mutualized: 'Shared',
  pdf_form_vol_liters: '% / Vol. in Liters',
  pdf_form_col_pct: '%',
  pdf_form_col_vol: 'Vol.',
  pdf_form_col_press: 'Prs.',
  pdf_form_col_liters: 'Lit.',
  pdf_form_yes: 'yes',
  pdf_form_no: 'no',
  pdf_form_gas_switch_legend: 'gas switch',
  pdf_form_gas_verdict_legend: "Diver 1 Lit. cell: green = OK, orange = tight, red = short for the bailout ascent, grey = not breathed. Figures in the right hand column.",
  pdf_form_dtr: 'TTS',

  // Safety Alerts
  alerts_summary_title: 'Points to check on this plan',
  alert_hypoxia: 'ppO2 {value} bar is below the 0.16 bar minimum: this mix is not breathable at this depth. Plan a gas richer in oxygen.',
  alert_hyperoxia: 'ppO2 {value} bar is above the 1.6 bar maximum. Lower the oxygen fraction or use this gas shallower.',
  alert_end_critical: 'END {value}m is beyond the 40m limit. Add helium to the bottom mix to reduce narcosis.',
  alert_end_high: 'END {value}m is above the recommended 30m. A mix richer in helium reduces narcosis.',
  alert_density_critical: 'Gas density {value} g/L is above the recommended 6.2 g/L: breathing may get harder at this depth. Add helium to the bottom mix.',
  alert_density_high: 'Gas density {value} g/L is above the 5.2 g/L advised on a rebreather. Keep exertion low or add helium to the diluent.',
  alert_narcosis_increase: 'ppN2 rises from {ccrValue} to {value} bar when switching to bailout: narcosis is higher than on the rebreather. A bailout richer in helium softens the transition.',
  alert_end_increase: 'END rises from {ccrValue}m to {value}m when switching to bailout. A bailout richer in helium reduces this gap.',
  alert_icd_risk: 'Helium drops from {prevValue}% to {value}% at this gas switch. A more gradual switch (intermediate mix) avoids isobaric counterdiffusion.',
  alert_ceiling_violation: 'This profile ascends to {depth}m while the deco ceiling is at {ceiling}m. Stay below the ceiling and extend the stop before ascending.',
  alert_stop_time_truncated: 'Stop at {depth}m capped at {time} min: the internal calculation limit was reached without clearing the ceiling. This plan is incomplete, do not dive it - shorten the bottom time, add a deco gas or raise GF High.',
  alert_runtime_limit: 'Calculation stopped at the internal runtime limit of {runtime} min: this plan is incomplete, do not dive it - shorten the dive or add a richer deco gas.',
  alert_entry_ceiling: 'Ceiling at {ceiling}m when this dive starts, under the gradient factors set here: the {interval} min surface interval does not clear the previous dive, so the diver already owes a stop before getting back in the water. This plan pays it back on the way up - lengthen the interval before diving it.',
  alert_residual_state_unloaded: 'Residual tissue state with no load at all: it says it follows a dive, yet not one compartment is above its resting level. This plan is therefore shorter than the same dive planned on clean tissues - do not dive it, calculate the previous dive again.',
  alert_default_gas_fallback: 'No active gas mix: this plan was computed on air by default. It is not the plan of the gases you configured - enable at least one gas in the Gases view and calculate again before diving.',
  alert_gas_above_mod: 'No carried gas reaches {depth}m under the {limit} bar ppO2 limit in force there: this plan holds {gas}, past its {mod}m MOD at that limit, at ppO2 {ppO2} bar. It is the leanest mix of your list, picked by default and not by you - carry a mix suited to that depth, or raise the limit, before diving.',
  alert_gas_switch_on_empty: 'The {gas} cylinder runs dry at {depth}m: the gas change shown there is not a deco switch you planned, it is the plan moving on to what is left. Carry more of that mix, or plan a switch of your own above that depth, before diving.',
  alert_gas_exhausted: 'Every cylinder usable at {depth}m is empty: from there this plan prescribes gas you are no longer carrying. Add capacity, or a mix that reaches that depth, before diving.',
  alert_gas_insufficient: 'The {gas} cylinders hold {capacity}L and this plan breathes {liters}L of that mix: short by {missing}L. Carry more of it, or plan a shorter dive, before diving.',
  alert_flush_not_reached: 'The loop flush planned at {depth}m never happens: the final ascent starts at {ascentStart}m, above it. Move the flush shallower, or make it the last level of the dive.',
  alert_flush_ppo2: 'The {depth}m flush on {gas} puts the loop at {ppO2} bar of oxygen, outside your {min} - {max} bar working band. During a flush the setpoint does not hold: the loop is whatever the mix gives at that depth.',
  alert_o2_flush_too_deep: 'The oxygen finish planned at {depth}m never happens: this dive never goes below {maxDepth}m, so no ascent passes through that depth.',

  // Plan validation errors
  plan_error_title: 'Plan cannot be calculated',
  plan_error_no_segments: 'No dive segment: add at least one segment with a depth and a time.',
  plan_error_invalid_depth: 'Invalid depth: enter a depth of 0 m or more for every segment (0 m is a surface interval).',
  plan_error_invalid_time: 'Invalid time: enter a duration of 0 min or more for every segment.',
  plan_error_invalid_gf: 'Invalid gradient factors: GF Low must be lower than or equal to GF High, and both above 0% and at most 100%.',
  plan_error_invalid_gas: 'Invalid gas mix: the O2 fraction must be above 0% and at most 100%, the He fraction from 0% to below 100%, and their sum must not exceed 100%.',
  plan_error_no_diluent: 'No valid diluent: choose a diluent for the rebreather dive in the Gases view.',
  plan_error_invalid_setpoint: 'Invalid setpoint: enter a ppO2 setpoint between 0.4 and 1.6 bar, bounds included.',
  plan_error_no_bailout_gas: 'No active bailout gas: enable at least one bailout gas in the Gases view to compute the bailout.',
  plan_error_invalid_config: 'Invalid planner setting: an ascent or descent rate, a stop depth or a ppO2 limit is out of range. Check the planner settings before calculating.',
  plan_error_invalid_tissue_state: 'Unusable residual tissue state: the previous dive of the series could not be read. Calculate the previous dive again before planning this one.',
  plan_error_invalid_surface_interval: 'Invalid surface interval: enter a duration of 0 min or more between the previous dive and this one.',
  plan_error_invalid_flush: 'Invalid loop flush: give each flush a depth above the bottom, a duration above 0 min, and only one flush per depth.',
  plan_error_time_shorter_than_descent: 'Segment time shorter than its descent: reaching {depth} m takes {descentTime} min at the configured descent rate, and the segment is given {time} min. The descent time is included in the segment time (see settings): enter a longer time, or untick that option.',
  plan_error_segment_gas_unavailable: 'Segment {index} ({depth} m) is planned on {gas}, which is disabled or no longer exists. Enable that gas in the Gases view, or pick another one for the segment.',
  plan_error_no_bailout_point: 'The rebreather plan carries no bailout point: it was not produced by this version of the planner. Calculate the rebreather plan again before its bailout.',

  // Dive Info
  plan_notes: 'Notes',
  plan_notes_placeholder: 'Add notes for the printed plan (reminders, instructions, etc.)',
  plan_divers_placeholder: 'Divers for this dive',

  // App Store Links
  app_available_on: 'Available on:',
  app_get_ios: 'Get it on App Store',
  app_get_android: 'Get it on Google Play',

  // Tissue compartment descriptions
  tissue_desc_1: 'Blood, spinal cord',
  tissue_desc_2: 'Blood, brain',
  tissue_desc_3: 'Brain, nerve tissue',
  tissue_desc_4: 'Well-perfused muscles',
  tissue_desc_5: 'Skin, viscera',
  tissue_desc_6: 'Muscles, organs',
  tissue_desc_7: 'Muscles',
  tissue_desc_8: 'Muscles, ligaments',
  tissue_desc_9: 'Tendons, connective tissue',
  tissue_desc_10: 'Cartilage',
  tissue_desc_11: 'Cartilage, bones',
  tissue_desc_12: 'Bones, joints',
  tissue_desc_13: 'Bones, fat',
  tissue_desc_14: 'Fat tissue',
  tissue_desc_15: 'Fat, bone marrow',
  tissue_desc_16: 'Fat, bone marrow',
  tissue_halftime: 'Half-time',
  tissue_speed_fast: 'fast tissue',
  tissue_speed_medium: 'medium tissue',
  tissue_speed_slow: 'slow tissue',
  tissue_leading: 'Leading compartment',
  tissue_leading_detail: '{tissue} (C{num}) controls your ceiling at {ceiling}m - loaded at {gf}% (GF {gfLow}/{gfHigh}, limit here: {gfLimit}%)',
  tissue_leading_no_ceiling: '{tissue} (C{num}) is the most loaded - loaded at {gf}% (GF {gfLow}/{gfHigh}, limit here: {gfLimit}%)',
  tissue_detail_title: 'Compartment detail',
  tissue_detail_coefficients: '{algo} coefficients: a={a} (supersaturation tolerance), b={b} (depth sensitivity). Empirical constants from Bühlmann - fast tissues (C1) tolerate more (a=1.17), slow tissues (C16) less (a=0.23).',
  tissue_detail_saturation: 'Saturation',
  tissue_detail_gf_actual: 'Actual GF',
  tissue_detail_no_supersaturation: 'No supersaturation',
  tissue_detail_undersaturated: 'This compartment is not supersaturated: tissue pressure is below ambient pressure. The GF concept only applies when the tissue is supersaturated (ascending or at a stop).',
  tissue_detail_explanation: '{saturation}% saturation does not mean {saturation}% GF. The GF ({gfActual}%) measures the fraction of margin used between ambient pressure and M-value. With GF High {gfHigh}%, a saturation of {saturation}% is expected.',
  tissue_detail_explanation_gf_low: 'GF Low ({gfLow}%) determines the depth of the first decompression stop. This is where the algorithm first allows the diver to stop during ascent: the leading compartment uses {gfUsed}% of its margin between ambient pressure and M-value. The lower the GF Low, the deeper the stops begin.',
  tissue_detail_explanation_interpolated: 'Between the first stop and the surface, the GF is linearly interpolated from GF Low ({gfLow}%) to GF High ({gfHigh}%). At this depth, the applied limit is {gfUsed}%. The actual GF of this compartment is {gfActual}%.',

  // Disclaimer
  disclaimer_title: 'Disclaimer',
  disclaimer_text: 'This software is a dive planning aid only. It does not replace proper training, experience, or judgment. The authors accept no responsibility for accidents or incidents. Always verify your plan with other tools and carry backup tables.',
  disclaimer_short: 'Planning aid only - does not replace training or judgment - no liability accepted',

  // Support the project
  support_nav: 'Support the project',
  support_nav_website: 'The project',
  support_title: 'Support MV-Plan',
  support_intro: 'MV-Plan is free software. No ads, no account to create, no data collected, and every feature is available to everyone. That will not change.',
  support_costs_title: 'What the project costs',
  support_cost_apple: 'Apple developer account: USD 99 per year, due even though the app is free.',
  support_cost_google: 'Google Play developer account: USD 25, one off.',
  support_cost_domain: 'Domain name and hosting for the mvplan.org website.',
  support_cost_time: 'The time spent building, testing and documenting the planner.',
  support_amount: 'A few euros are enough. Most contributions are between 3 and 10 euros, and that already helps a lot.',
  support_nothing_unlocked: 'Contributing unlocks nothing: there is no paid version, no hidden option, no name on a wall. The app stays the same for everyone.',
  support_thanks: 'Thanks to everyone who has already contributed.',
  support_button: 'Contribute',
  support_link_label: 'Page address',
  support_copy: 'Copy link',
  support_copied: 'Link copied',
  support_copy_failed: 'Could not copy, please select the address by hand',
  support_open_hint: 'If the button opens nothing, copy the address above into your browser.',
  support_website_title: 'The project',
  support_website_intro: 'MV-Plan is free software, built in its author\'s spare time. The project website carries the documentation, the release notes and the contact details.',
  support_website_button: 'Open the project website'
}
